import React, {Component} from 'react';
import {connect} from 'react-redux';
import {Button, Col, Row, message} from 'antd';
import {CardElement, ElementsConsumer} from '@stripe/react-stripe-js';
import SubscriptionActions from 'bukku/redux/Subscription/actions';
import AppActions from 'bukku/redux/App/actions';
import CardSection from './CardSection';
import { Trans, t } from '@lingui/macro';
import SelfBillingTextInfo from '../Modal/SubscribeSwitchPlan/components/BillingTextV2/variants/SelfBillingTextInfo';

const {
    readClientSecret,
    readCompanyClientSecret,
    setModalCurrentStep,
} = SubscriptionActions;
const {
    startPushing,
    stopPushing,
} = AppActions;

class CardSetupForm extends Component {
    componentDidMount() {
        const {
            readClientSecret,
            readCompanyClientSecret,
            isLoggedIn,
        } = this.props;

        if (isLoggedIn)
            readCompanyClientSecret();
        else
            readClientSecret();
    }

    handleSubmit = async event => {
        event.preventDefault();

        const {
            stripe,
            elements,
            clientSecret,
            validateForm,
            asyncValidateForm,
            onSubmit,
            startPushing,
            stopPushing,
        } = this.props;

        // The main form is dirty. (Form V3)
        if (validateForm && !validateForm())
            return;

        // Form V4
        if (asyncValidateForm && !(await asyncValidateForm()))
            return;

        if (!stripe || !elements) {
            // Stripe.js has not yet loaded.
            // Make  sure to disable form submission until Stripe.js has loaded.
            return;
        }

        startPushing();

        const result = await stripe.confirmCardSetup(clientSecret, {
            payment_method: {
                card: elements.getElement(CardElement),
            },
        });

        if (result.error) {
            // Display result.error.message in your UI.
            message.error(result.error.message);
            stopPushing();
        }
        else {
            // The setup has succeeded. Display a success message and send
            // result.setupIntent.payment_method to your server to save the
            // card to a Customer
            stopPushing();

            // Submit
            onSubmit(event, result.setupIntent.payment_method);
        }
    };

    render() {
        const {
            stripe,
            buttonLabel,
            isPushing,
            setModalCurrentStep,
            step,
            hideBillingText,
            hideBackButton
        } = this.props;

        return (
            <>
                <CardSection />
                {hideBillingText ? null : <SelfBillingTextInfo />}
                <div className="button" style={{marginTop: '16px'}}>
                    <Row type="flex" justify="end" gutter={[8, 8]}>
                        { hideBackButton ? null : <Col>
                            <Button
                                onClick={() => {
                                    setModalCurrentStep(step - 1);
                                }}
                            >
                                <Trans>Back</Trans>
                            </Button>
                        </Col>
                        }
                        <Col>
                            <Button
                                type="primary"
                                htmlType="submit"
                                disabled={!stripe}
                                loading={isPushing}
                                onClick={this.handleSubmit}
                                // size="normal"
                            >
                                { buttonLabel || t`Subscribe` }
                            </Button>
                        </Col>
                    </Row>
                </div>
            </>
        );
    }
}

const ConnectedCardSetupForm = connect(state => ({
    isPushing: state.App.isPushing,
    clientSecret: state.Subscription.clientSecret,
    step: state.Subscription.modalCurrentStep,
    isLoggedIn: state.Auth.accessToken !== null,
}), {
    readClientSecret,
    readCompanyClientSecret,
    setModalCurrentStep,
    startPushing,
    stopPushing,
})(CardSetupForm);

export default function InjectedCardSetupForm({ validateForm, onSubmit, buttonLabel, hideBillingText, hideBackButton }) {
    return (
        <ElementsConsumer>
            {({stripe, elements}) => (
                <ConnectedCardSetupForm
                    validateForm={validateForm}
                    onSubmit={onSubmit}
                    buttonLabel={buttonLabel}
                    stripe={stripe}
                    elements={elements}
                    hideBillingText={hideBillingText}
                    hideBackButton={hideBackButton}
                />
            )}
        </ElementsConsumer>
    );
}
